import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const defaultNS = "common";

export const namespaces = [
  "agents",
  "common",
  "companies",
  "homePage",
  "profiles",
  "search",
  "signIn",
  "users",
  "notifications",
  "actions",
  "migrationReport",
  "migrationStatus",
  "formDataInjector",
  "formData",
] as const;

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("lng") || "en-US",
    fallbackLng: "fr-FR",

    ns: [...namespaces],
    defaultNS,

    backend: {
      loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json`,
    },

    interpolation: {
      escapeValue: false,
    },

    debug: import.meta.env.DEV,
  });

export default i18n;
